module.exports = __webpack_public_path__ + "img/ohra_logo.a524eb98.png";